import { ActivityModel, FlowDefinitionModel } from '../Models/FlowModel';
import { FlowValidationIssue } from '../Models/FlowSaveError';
import { FlowNode } from '../Models/GraphModel';

/** Resolve against the submitted definition, whose array indices match the server paths. */
export function groupActivityValidationIssues(definition: FlowDefinitionModel, issues: FlowValidationIssue[]): ReadonlyMap<string, FlowValidationIssue[]> {
	const activities: { id: string; path: string }[] = [];
	const visit = (content: ActivityModel[], path: string) => {
		content.forEach((activity, index) => {
			const activityPath = `${path}.Content[${index}]`;
			activities.push({ id: activity.Id, path: activityPath });
			if (Array.isArray(activity.Content)) {
				visit(activity.Content as ActivityModel[], activityPath);
			}
		});
	};
	visit(definition.Content, '$');
	activities.sort((a, b) => b.path.length - a.path.length);
	const grouped = new Map<string, FlowValidationIssue[]>();
	for (const issue of issues) {
		const activity = activities.find(({ path }) => issue.path === path || issue.path.startsWith(`${path}.`) || issue.path.startsWith(`${path}[`));
		if (activity) {
			const entries = grouped.get(activity.id) ?? [];
			entries.push(issue);
			grouped.set(activity.id, entries);
		}
	}
	return grouped;
}

/** Surface hidden children's issues on their closest visible container. */
export function visibleActivityValidationIssues(issues: ReadonlyMap<string, FlowValidationIssue[]>, nodes: FlowNode[]): ReadonlyMap<string, FlowValidationIssue[]> {
	const nodesById = new Map(nodes.map((node) => [node.id, node]));
	const visible = new Map<string, FlowValidationIssue[]>();
	issues.forEach((entries, id) => {
		let node = nodesById.get(id);
		const visited = new Set<string>();
		while (node?.hidden && node.parentId && !visited.has(node.id)) {
			visited.add(node.id);
			node = nodesById.get(node.parentId);
		}
		if (node && !node.hidden) {
			visible.set(node.id, [...(visible.get(node.id) ?? []), ...entries]);
		}
	});
	return visible;
}
